import { render, staticRenderFns } from "./NDashboardFolders.vue?vue&type=template&id=5f669f73&scoped=true&"
import script from "./NDashboardFolders.vue?vue&type=script&lang=js&"
export * from "./NDashboardFolders.vue?vue&type=script&lang=js&"
import style0 from "./NDashboardFolders.vue?vue&type=style&index=0&id=5f669f73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f669f73",
  null
  
)

export default component.exports